// extracted by mini-css-extract-plugin
export default {"shop-items":"shop-items_shop-items__L0RzE","item":"shop-items_item__XGGkC","title":"shop-items_title__Y1fnL","price":"shop-items_price__LVAkb"};